// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.107.2_postcss@8.5.15_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.107.2_postcss@8.5.15_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.comment-section {
    width: 100%;
    margin-top: 28px;
    padding-top: 22px;
    border-top: 1px solid var(--tp-rule);
    color: var(--tp-ink);
    animation: comment-enter 180ms ease-out;
}

@keyframes comment-enter {
    from { opacity: 0; transform: translateY(-5px); }
    to { opacity: 1; transform: translateY(0); }
}

.comment-write-card {
    width: 100%;
    margin-bottom: 24px;
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto;
    gap: 8px;
    align-items: end;
}

.comment-textarea {
    width: 100%;
    min-height: 48px;
    padding: 13px 14px;
    resize: vertical;
    border: 1px solid var(--tp-rule);
    border-radius: var(--tp-radius-control);
    outline: 0;
    background: var(--tp-sheet);
    color: var(--tp-ink);
    font-size: 13px;
    line-height: 1.55;
}

.comment-textarea:focus { border-color: var(--tp-ink); }

.comment-submit-button {
    min-width: 64px;
    min-height: 48px;
    padding: 0 14px;
    border: 1px solid var(--tp-ink);
    border-radius: var(--tp-radius-control);
    background: var(--tp-ink);
    color: var(--tp-sheet);
    font-size: 12px;
    font-weight: 800;
    cursor: pointer;
}

.comment-list {
    display: grid;
    gap: 0;
}

.comment-card {
    padding: 18px 0;
    border-top: 1px solid var(--tp-rule);
    background: transparent;
}

.comment-content {
    margin-bottom: 13px;
    color: var(--tp-ink);
    font-size: 14px;
    line-height: 1.65;
    word-break: break-word;
}

.comment-bottom-row,
.comment-user-wrap,
.comment-inline-meta {
    display: flex;
    align-items: center;
}

.comment-bottom-row { justify-content: space-between; gap: 14px; }
.comment-user-wrap { gap: 9px; min-width: 0; }
.comment-inline-meta { gap: 6px; min-width: 0; }

.comment-avatar {
    width: 30px;
    height: 30px;
    flex: 0 0 30px;
    display: grid;
    place-items: center;
    border: 1px solid var(--tp-rule);
    border-radius: 50%;
    background: #ebe6dc;
    color: var(--tp-ink);
    font-size: 11px;
    font-weight: 850;
}

.comment-nickname {
    color: var(--tp-ink);
    font-size: 12px;
    font-weight: 800;
}

.comment-dot,
.comment-date {
    color: var(--tp-muted);
    font-size: 11px;
}

.comment-item-delete-btn {
    min-width: 44px;
    min-height: 36px;
    padding: 0 8px;
    border: 1px solid rgba(180, 35, 24, .24);
    border-radius: 8px;
    background: transparent;
    color: var(--tp-error);
    font-size: 11px;
    font-weight: 750;
    cursor: pointer;
}

@media (max-width: 480px) {
    .comment-write-card { grid-template-columns: 1fr; }
    .comment-submit-button { width: 100%; }
    .comment-date { max-width: 112px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
}
`, "",{"version":3,"sources":["webpack://./src/components/CommentSection.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,oCAAoC;IACpC,oBAAoB;IACpB,uCAAuC;AAC3C;;AAEA;IACI,OAAO,UAAU,EAAE,2BAA2B,EAAE;IAChD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC/C;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,aAAa;IACb,0CAA0C;IAC1C,QAAQ;IACR,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,gCAAgC;IAChC,uCAAuC;IACvC,UAAU;IACV,2BAA2B;IAC3B,oBAAoB;IACpB,eAAe;IACf,iBAAiB;AACrB;;AAEA,0BAA0B,2BAA2B,EAAE;;AAEvD;IACI,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,+BAA+B;IAC/B,uCAAuC;IACvC,yBAAyB;IACzB,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,MAAM;AACV;;AAEA;IACI,eAAe;IACf,oCAAoC;IACpC,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;IACnB,oBAAoB;IACpB,eAAe;IACf,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;;;IAGI,aAAa;IACb,mBAAmB;AACvB;;AAEA,sBAAsB,8BAA8B,EAAE,SAAS,EAAE;AACjE,qBAAqB,QAAQ,EAAE,YAAY,EAAE;AAC7C,uBAAuB,QAAQ,EAAE,YAAY,EAAE;;AAE/C;IACI,WAAW;IACX,YAAY;IACZ,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,gCAAgC;IAChC,kBAAkB;IAClB,mBAAmB;IACnB,oBAAoB;IACpB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;IACpB,eAAe;IACf,gBAAgB;AACpB;;AAEA;;IAEI,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,wCAAwC;IACxC,kBAAkB;IAClB,uBAAuB;IACvB,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,sBAAsB,0BAA0B,EAAE;IAClD,yBAAyB,WAAW,EAAE;IACtC,gBAAgB,gBAAgB,EAAE,gBAAgB,EAAE,uBAAuB,EAAE,mBAAmB,EAAE;AACtG","sourcesContent":[".comment-section {\n    width: 100%;\n    margin-top: 28px;\n    padding-top: 22px;\n    border-top: 1px solid var(--tp-rule);\n    color: var(--tp-ink);\n    animation: comment-enter 180ms ease-out;\n}\n\n@keyframes comment-enter {\n    from { opacity: 0; transform: translateY(-5px); }\n    to { opacity: 1; transform: translateY(0); }\n}\n\n.comment-write-card {\n    width: 100%;\n    margin-bottom: 24px;\n    display: grid;\n    grid-template-columns: minmax(0, 1fr) auto;\n    gap: 8px;\n    align-items: end;\n}\n\n.comment-textarea {\n    width: 100%;\n    min-height: 48px;\n    padding: 13px 14px;\n    resize: vertical;\n    border: 1px solid var(--tp-rule);\n    border-radius: var(--tp-radius-control);\n    outline: 0;\n    background: var(--tp-sheet);\n    color: var(--tp-ink);\n    font-size: 13px;\n    line-height: 1.55;\n}\n\n.comment-textarea:focus { border-color: var(--tp-ink); }\n\n.comment-submit-button {\n    min-width: 64px;\n    min-height: 48px;\n    padding: 0 14px;\n    border: 1px solid var(--tp-ink);\n    border-radius: var(--tp-radius-control);\n    background: var(--tp-ink);\n    color: var(--tp-sheet);\n    font-size: 12px;\n    font-weight: 800;\n    cursor: pointer;\n}\n\n.comment-list {\n    display: grid;\n    gap: 0;\n}\n\n.comment-card {\n    padding: 18px 0;\n    border-top: 1px solid var(--tp-rule);\n    background: transparent;\n}\n\n.comment-content {\n    margin-bottom: 13px;\n    color: var(--tp-ink);\n    font-size: 14px;\n    line-height: 1.65;\n    word-break: break-word;\n}\n\n.comment-bottom-row,\n.comment-user-wrap,\n.comment-inline-meta {\n    display: flex;\n    align-items: center;\n}\n\n.comment-bottom-row { justify-content: space-between; gap: 14px; }\n.comment-user-wrap { gap: 9px; min-width: 0; }\n.comment-inline-meta { gap: 6px; min-width: 0; }\n\n.comment-avatar {\n    width: 30px;\n    height: 30px;\n    flex: 0 0 30px;\n    display: grid;\n    place-items: center;\n    border: 1px solid var(--tp-rule);\n    border-radius: 50%;\n    background: #ebe6dc;\n    color: var(--tp-ink);\n    font-size: 11px;\n    font-weight: 850;\n}\n\n.comment-nickname {\n    color: var(--tp-ink);\n    font-size: 12px;\n    font-weight: 800;\n}\n\n.comment-dot,\n.comment-date {\n    color: var(--tp-muted);\n    font-size: 11px;\n}\n\n.comment-item-delete-btn {\n    min-width: 44px;\n    min-height: 36px;\n    padding: 0 8px;\n    border: 1px solid rgba(180, 35, 24, .24);\n    border-radius: 8px;\n    background: transparent;\n    color: var(--tp-error);\n    font-size: 11px;\n    font-weight: 750;\n    cursor: pointer;\n}\n\n@media (max-width: 480px) {\n    .comment-write-card { grid-template-columns: 1fr; }\n    .comment-submit-button { width: 100%; }\n    .comment-date { max-width: 112px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
